module.exports = {"MODAL":{"FOOTER":{"DISMISS":"Dismiss","SAVE":"Save"}}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/en/modal.json
// module id = 700
// module chunks = 0